import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../components-css/QuienesSomos.css';

const QuienesSomos = () => {
  return (
    <section id="quienes-somos" className="quienes-somos">
      <Container>
        <div className="section-title text-center mb-4">
          <h2 className="section-title__title">Quiénes somos</h2>
        </div>
        <p className="quienes-somos__text">
          Somos la Iglesia Canal de Vida, una gran familia donde cada persona es bienvenida tal como es. <br></br>
          Aquí podés encontrarte con Jesús, conectar con una comunidad que te abraza y crecer en la fe junto a otros.
          Queremos caminar juntos, apoyarnos y celebrar lo que Dios hace en cada historia.<br></br>
          ¡Te esperamos para compartir y sentirte en casa!
        </p>
        <div className="text-center mt-4">
          <Link to="/conocer-a-dios" className="btn-conocer-dios">
            ¿Quisieras conocer a Dios?
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default QuienesSomos;